<section class="password section-reset-password w-100 d-flex background-grey justify-content-center align-items-center">
    <div class="d-flex p-4">
        <app-back-button url="./login" class="back-button">BACK LOGIN</app-back-button>
        <mat-card appearance="outlined" class="password-form-reset-container sticky-top-10 px-3 px-sm-5 py-5">
            <div class="d-flex justify-content-center reset-logo">
                <app-facility-logo class="logo" [width]="widthLogo" [height]="heightLogo" />
            </div>
            <h1 class="foreground-primary-default mat-headline-4 m-0 text-center mt-3 mb-3">Make a new password</h1>
            <form [formGroup]="resetFormPassword" (submit)="recoverPassword($event, resetFormPassword)">
                <mat-form-field class="col-12">
                    <mat-label>Password</mat-label>
                    <input
                        matInput
                        id="input-password-company"
                        minlength="8"
                        placeholder="Enter password"
                        formControlName="password"
                        [type]="hidePassword ? 'password' : 'text'"
                        matTooltip="Password must contains at least: Minimum 8 characters, at least one letter, at least one number"
                    />
                    <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{
                        hidePassword ? 'visibility_off' : 'visibility'
                    }}</mat-icon>
                    <mat-error>
                        <app-field-error [field]="'password'" [messageList]="formErrors['password']" />
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="col-12">
                    <mat-label>Confirm password</mat-label>
                    <input
                        matInput
                        id="input-password-confirm"
                        minlength="8"
                        placeholder="Confirm password"
                        formControlName="confirmPassword"
                        [type]="hidePasswordConfirm ? 'password' : 'text'"
                    />
                    <mat-icon matSuffix (click)="hidePasswordConfirm = !hidePasswordConfirm">{{
                        hidePasswordConfirm ? 'visibility_off' : 'visibility'
                    }}</mat-icon>
                    <mat-error>
                        <app-field-error [field]="'confirmPassword'" [messageList]="formErrors['confirmPassword']" />
                    </mat-error>
                </mat-form-field>
                <mat-error>
                    <app-form-error [messageList]="formErrors['form']" />
                </mat-error>
                <button
                    matButton="filled"
                    type="submit"
                    class="btn-reset w-100"
                    [disabled]="resetFormPassword.invalid"
                    color="primary"
                >
                    RESET PASSWORD
                </button>
            </form>
            <p class="mat-subtitle-1 mt-4 text-center">
                Do you already have an account?
                <button type="button" (click)="back()" mat-button color="primary" class="primary link mat-subtitle-2">
                    LOGIN
                </button>
            </p>
        </mat-card>
    </div>
</section>
